import { Header } from '@/features/header';
import { Navigation } from '@/features/navigation';
import { NavigationProvider } from '@/features/navigation/context/NavigationContext';
import { Outlet } from 'react-router';

export default function MainLayout() {
  return (
    <NavigationProvider>
      <div className="flex h-screen flex-col overflow-hidden">
        <Header />
        <div className="flex flex-1 overflow-hidden">
          <Navigation />
          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </NavigationProvider>
  );
}
